import * as z from "zod";
import { clientGeneratableIdSchema } from "../id";
import { mutator } from "./mutator";

export const recordGalleryWorkflowImported = mutator({
  schema: z.object({
    galleryWorkflowId: clientGeneratableIdSchema,
    galleryCommitId: clientGeneratableIdSchema,
  }),
  resolve: {},
  permissions: {
    none: "records that the caller imported a gallery workflow",
  },
  fn: async () => {},
});
